/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: b985c4059dd2
 */

import * as z from "zod";

export type TestTriggerResponse = {
  trigger_id: string;
  filter_present: boolean;
  filter_result: boolean;
};

export const TestTriggerResponse$zodSchema: z.ZodType<TestTriggerResponse> = z
  .object({
    filter_present: z.boolean().describe(
      "Whether the trigger has a filter configured.",
    ),
    filter_result: z.boolean().describe(
      "Result of evaluating the filter against sample_data (true if no filter).",
    ),
    trigger_id: z.string().describe("The ID of the trigger that was tested."),
  });
